import React, { useEffect, useState } from "react";
import Sidebar from "../Side/Sidebar";
import Topbar from "../Side/Topbar";
import AOS from 'aos';
import 'aos/dist/aos.css';
import BlogSection from "../Cards/BlogSection";
import { useAuth } from "../Auth/AuthContext"; // Import useAuth
import AdminSidebar from "../Side/AdminSidebar";
import PublisherHome from "../Home/PublisherHome";

const Home = () => {
    const { authState } = useAuth(); // Get authState from AuthContext
    const role = authState.roles;
    const admin = role === "Admin";

    useEffect(() => {
        AOS.init({
            duration: 1000, // Animation duration in milliseconds
            once: true, // Whether animation should happen only once
        });
    }, []);

    return (
        <div>
            <div className="mt-6">
                <PublisherHome />
                <BlogSection />
            </div>
        </div>
    );
};

export default Home;